import { Fragment } from "react";

const PageNotFound = () => {
  return (
    <Fragment>
      <div className="bg-orange-notfound d-flex" style={{ height: "60vh", marginBottom: "3rem", textAlign: "center" }}>
        <div style={{ margin: "auto" }}>
          <h3>404</h3>
          <h3>Page Not Found</h3>
        </div>
      </div>
    </Fragment>
  );
};

export default PageNotFound;
